import { Bounds, Container, Sprite } from "pixi.js";
import { Tween } from "tweedle.js";
import { Manager } from "./core/Manager";

export function isFireFox(): boolean {
    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    if (/firefox/i.test(ua)) return true;

    const uaData = (navigator as any).userAgentData;
    if (uaData?.brands?.some((b: any) => /firefox/i.test(b.brand))) return true;
    if (uaData?.platform === 'Android' && uaData?.brands?.some((b: any) => /firefox/i.test(b.brand))) return true;
    return typeof (window as any).InstallTrigger !== 'undefined';
}

export async function wait(ms: number) {
    return new Promise((resolve) => {
        new Tween({})
            .delay(ms)
            .onAfterDelay(resolve) // Resolve the promise when delay ends
            .start();
    });
}

// import gsap from 'gsap';

// export function shakeContainers(containers: Container[], isDrilling: boolean) {
//     if (!isDrilling) {
//         gsap.killTweensOf(containers);
//         gsap.set(containers, { x: 0, y: 0 });
//         return;
//     }

//     containers.forEach((container: Container) => {
//         gsap.to(container, {
//             x: "random(-2, 2)",
//             y: "random(-2, 2)",
//             duration: 0.1,
//             repeat: -1,
//             yoyo: true,
//             ease: "none"
//         });
//     });
// }


export function getVisibleLocalBounds(container: Container) {
    const bounds = new Bounds();

    container.children.forEach(child => {

        if (!child.visible || child.alpha <= 0) return;

        const childBounds = child.getBounds();
        bounds.addBounds(childBounds);
    });

    return bounds;
}

export function positionReelFrame(container: Container, guide: Sprite) {
    container.pivot.x = (guide.width / 2);
    container.pivot.y = (guide.height / 2);

    container.x = Manager.screenwidth / 2;
    container.y = Manager.screenHeight / 2;
}
